import { ISingleHeartbeatMessage, IClusterHeartbeatMessage, HeartbeatMode } from "./interfaces";
import { IMachineCenter } from "contexts/HMICachedDataContext/HMICachedDataContextInterfaces";
import { IClusterMachineCenter } from "contexts/ClusterCachedDataContext/ClusterCachedDataContextInterfaces";
import { HMIS_ALIVE_STATUS_TOPIC_PREFIX } from "constants/constants";
import * as mqtt from "precompiled-mqtt";

const formatTimestamp = (): string => {
    return new Date().toISOString();
};

const getAppVersion = (): string => {
    return process.env.REACT_APP_VERSION || "unknown";
};

export const buildTopic = (mode: HeartbeatMode, id?: number): string => {
    if (mode === HeartbeatMode.SINGLE) {
        return `${HMIS_ALIVE_STATUS_TOPIC_PREFIX}/hmi-${id}`;
    } else {
        return `${HMIS_ALIVE_STATUS_TOPIC_PREFIX}/cluster-${id}`;
    }
};

export const publishSingleHeartbeat = (
    client: mqtt.MqttClient,
    topic: string,
    machineCenter: IMachineCenter,
): Promise<void> => {
    return new Promise((resolve, reject) => {
        try {
            const message: ISingleHeartbeatMessage = {
                name: machineCenter.name,
                id: machineCenter.machine_center_id,
                plcAddress: machineCenter.plc_address || null,
                timestamp: formatTimestamp(),
                version: getAppVersion(),
            };

            client.publish(topic, JSON.stringify(message), { qos: 1, retain: true }, (err) => {
                if (err) {
                    console.error(`Error publishing heartbeat to ${topic}:`, err);
                    reject(err);
                } else {
                    resolve();
                }
            });
        } catch (error) {
            console.error(`Error formatting heartbeat message for ${topic}:`, error);
            reject(error);
        }
    });
};

export const publishClusterHeartbeat = (
    client: mqtt.MqttClient,
    topic: string,
    clusterName: string,
    machineCenters: IClusterMachineCenter[],
): Promise<void> => {
    return new Promise((resolve, reject) => {
        try {
            const message: IClusterHeartbeatMessage = {
                clusterName,
                timestamp: formatTimestamp(),
                version: getAppVersion(),
                machineCenters: machineCenters.map((mc) => ({
                    name: mc.name,
                    id: mc.machine_center_id,
                    plcAddress: mc.plc_address || null,
                })),
            };

            client.publish(topic, JSON.stringify(message), { qos: 1, retain: true }, (err) => {
                if (err) {
                    console.error(`Error publishing heartbeat to ${topic}:`, err);
                    reject(err);
                } else {
                    resolve();
                }
            });
        } catch (error) {
            console.error(`Error formatting heartbeat message for ${topic}:`, error);
            reject(error);
        }
    });
};
